module.exports = __webpack_public_path__ + "assets/images/cockpit/active/btn_closedc_ru.png";